import { wplToken } from '@atlassiansox/wpl-token';
import { getColor } from '@atlassiansox/wpl-utils';
import { css } from '@emotion/react';

export const containerStyle = css`
  display: flex;
  padding: ${wplToken('space.400')} ${wplToken('space.300')};
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: ${wplToken('space.300')};
  border: 1px solid ${getColor('b400')};
  border-left-width: 0;
  border-right-width: 0;

  font-size: 1.125rem;
`;

export const breakdownStyle = css`
  display: flex;
  gap: ${wplToken('space.075')};
  width: 100%;
`;

export const frameStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${wplToken('space.075')};
  align-self: stretch;
  flex: 1 0 0;
`;

export const familyNameStyle = css`
  font-size: 1.125rem;
  font-weight: 500;
`;

export const productStyle = css`
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: 400;
  color: ${getColor('n800')};
  margin-top: 0.325rem;
`;

export const pricingStyle = css`
  font-size: 1rem;
  line-height: 1.625rem;
  text-align: right;
  flex: 1 0 0;
`;
